import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks"
import { PrimaryButton } from "./buttons/PrimaryButton";
import LanguageSelector from "./main_page/LanguageSelector"
import { MainMenuButton } from "./navbar/MainMenuButton"
import { SearchBar } from "./navbar/SearchBar"
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import logo from '../assets/images/Rentic_logo.svg';
import { FooterElement } from "./navbar/FooterElement";

export const Footer: React.FC = () => {
    const user = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();

    const [scrolled, setScrolled] = useState(false);
    const location = useLocation(); // Get the current route


    return (
        <div className={`w-full flex justify-center z-10 shadow-lg mt-[60px] pt-[40px] rounded-xl px-4 transition-all duration-200 bg-white`}>
            <div className="flex flex-col w-full justify-between text-left max-w-[1500px] border-t-[1px] border-primary">
                <div className="grid grid-cols-2 lg:flex py-16 flex-row gap-10">
                    <div className="flex flex-col gap-3 w-full">
                        <div>Rentic</div>
                        <div className="flex flex-col items-baseline">
                            <FooterElement text="Otsing" link="/" />
                            <FooterElement text="Uus kuulutus" link="/edit" />
                            <FooterElement text="Hinnakiri" link="/pricing" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <div>Minu Konto</div>
                        {user?.id ?
                            <div className="flex flex-col items-baseline">
                                <FooterElement text="Profiili andmed" link="/profile_edit" />
                                <FooterElement text="Meeldivaks märgitud" link="/favorites" />
                                <FooterElement text="Minu kuulutused" link="/my-adverts" />
                                <FooterElement text="Minu laenutatud" link="/my-orders" />
                                <FooterElement text="Logi välja" link="/my-orders" />

                            </div> :
                            <div className="flex flex-col items-baseline">
                                <FooterElement text="Logi sisse" link="/login" />
                                <FooterElement text="Loo konto" link="/signup" />
                            </div>

                        }
                    </div>
                    {user?.id &&
                        <div className="flex flex-col gap-3 w-full">
                            <div>Vestlused</div>

                            <div className="flex flex-col items-baseline">
                                <FooterElement text="Ostja rollis" link="/chats" />
                                <FooterElement text="Müüja rollis" link="/rentals-chats" />
                            </div>



                        </div>
                    }
                    <div className="flex flex-col gap-3 w-full">
                        <div>Abi</div>
                        <div className="flex flex-col items-baseline">
                            <FooterElement text="Privaatsuspoliitika" link="/privacy-policy" />
                            <FooterElement text="Teenustingimused" link="/terms-of-service" />
                            <FooterElement text="Teata väärkasutusest" link="/contact" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <div>Platvorm</div>
                        <div className="flex flex-col items-baseline">
                            <FooterElement text="Klienditoe kontakt" link="/contact"/>
                            <FooterElement text="Info@rentic.ee" link="mailto:info@rentic.ee"/>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3 w-full">
                        <div className="flex flex-col gap-3 items-baseline">
                            <img src={logo} alt="Rentic logo" className="w-[150px] grayscale" />
                            {/* <LanguageSelector /> */}
                        </div>
                    </div>

                </div>
                <div className="flex flex-row opacity-70 text-gray-700 font-light text-xs h-10 text-start mb-1 align-baseline">
                    <span>
                        Copyright © 2024 Rentic OÜ. Kõik Õigused Kaitstud. Platvormi ehitas: <a className="ml-1" href="https://spetsymarketing.com">Spetsy Marketing</a></span>
                </div>
            </div>
        </div>
    )
}